var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowWorkIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "how-work-icon3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "icon_Background_",
    "data-name": "icon (Background)",
    width: 80,
    height: 80,
    rx: 24,
    fill: "#ef466f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Medal_Line",
    "data-name": "icons/Medal/Line",
    transform: "translate(28 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,2a6,6,0,1,0,6,6A6.007,6.007,0,0,0,8,2Z",
    transform: "translate(4 8)",
    fill: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8ZM4,2A2,2,0,1,0,6,4,2,2,0,0,0,4,2Z",
    transform: "translate(8 12)",
    fill: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M2.109,3.447,4.692,8.613a7.99,7.99,0,0,0-1.738,1L.321,4.342A3,3,0,0,1,3,0H4.532A3,3,0,0,1,7.215,1.658l.553,1.106.553-1.106A3,3,0,0,1,11,0h1.528a3,3,0,0,1,2.683,4.342L12.581,9.609a7.99,7.99,0,0,0-1.738-1l2.583-5.165A1,1,0,0,0,12.532,2H11a1,1,0,0,0-.894.553L8.886,5l1.768,3.537a7.965,7.965,0,0,0-2.5-.527L5.426,2.553A1,1,0,0,0,4.532,2H3A1,1,0,0,0,2.109,3.447Z",
    transform: "translate(4.232)",
    fill: "#fcfcfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowWorkIcon3);
export default __webpack_public_path__ + "static/media/how-work-icon3.9682da53af2f570a23e8cb6b4815a9a6.svg";
export { ForwardRef as ReactComponent };